var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.5V13.5C3 13.7761 3.22386 14 3.5 14H12.5C12.7761 14 13 13.7761 13 13.5V11.5C13 11.2239 12.7761 11 12.5 11C12.2239 11 12 11.2239 12 11.5V13H4V11.5C4 11.2239 3.77614 11 3.5 11C3.22386 11 3 11.2239 3 11.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6543 7.83704C10.8496 8.0323 10.8496 8.34888 10.6543 8.54414L8.34492 10.8536C8.14966 11.0488 7.83308 11.0488 7.63782 10.8536L5.32841 8.54414C5.13315 8.34888 5.13315 8.0323 5.32841 7.83704C5.52367 7.64177 5.84025 7.64177 6.03551 7.83704L7.50787 9.3094L7.50787 2.49998C7.50787 2.22383 7.73173 1.99998 8.00787 1.99998C8.28402 1.99998 8.50787 2.22383 8.50787 2.49998L8.50787 9.27639L9.94723 7.83704C10.1425 7.64177 10.4591 7.64177 10.6543 7.83704Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.1733acd1e99d7ced169d47d950fd055b.svg";
export { ForwardRef as ReactComponent };